import users, { usersByWallet } from './users';

const now = new Date();
const daysAgo = (days) => new Date(now.getTime() - days * 86400000).toISOString();
const hoursAgo = (hours) => new Date(now.getTime() - hours * 3600000).toISOString();

const owner = (wallet) => {
  const user = usersByWallet[wallet.toLowerCase()];
  return {
    _id: user._id,
    name: user.name,
    wallet: user.wallet,
    avatar: user.avatar,
  };
};

const bid = (userId, amount, date) => {
  const user = users.find((item) => item._id === userId);
  return {
    _id: user._id,
    name: user.name,
    wallet: user.wallet,
    avatar: user.avatar,
    amount,
    date,
  };
};

const sales = [
  {
    _id: 'demo-sale-1',
    saleId: '101',
    type: 'auction',
    status: 'live',
    reservePrice: '150000000000000000',
    startDate: daysAgo(1),
    duration: 604800,
    seller: users[0].wallet,
    createdAt: daysAgo(2),
    bids: [
      bid('demo-user-3', '180000000000000000', hoursAgo(6)),
      bid('demo-user-5', '220000000000000000', hoursAgo(2)),
    ],
    nft: {
      _id: 'demo-nft-1',
      tokenId: '1001',
      title: 'Midnight Leather Tote',
      description: 'A handcrafted digital collectible inspired by Parisian ateliers.',
      file: '/demo/bag-1.png',
      creator: users[0].wallet,
      owner: owner(users[0].wallet),
      category: 'fashion',
      properties: [
        { name: 'Material', value: 'Leather' },
        { name: 'Edition', value: '1 of 1' },
      ],
      createdAt: daysAgo(5),
    },
  },
  {
    _id: 'demo-sale-2',
    saleId: '102',
    type: 'auction',
    status: 'live',
    reservePrice: '250000000000000000',
    startDate: daysAgo(0),
    duration: 604800,
    seller: users[1].wallet,
    createdAt: daysAgo(1),
    bids: [bid('demo-user-4', '280000000000000000', hoursAgo(4))],
    nft: {
      _id: 'demo-nft-2',
      tokenId: '1002',
      title: 'Cobalt Weekender',
      description: 'Limited-run weekender bag with signature Club Rare detailing.',
      file: '/demo/bag-2.png',
      creator: users[1].wallet,
      owner: owner(users[1].wallet),
      category: 'fashion',
      createdAt: daysAgo(4),
    },
  },
  {
    _id: 'demo-sale-3',
    saleId: '103',
    type: 'auction',
    status: 'live',
    reservePrice: '500000000000000000',
    startDate: daysAgo(2),
    duration: 604800,
    seller: users[2].wallet,
    createdAt: daysAgo(3),
    bids: [],
    nft: {
      _id: 'demo-nft-3',
      tokenId: '1003',
      title: 'Chronos Steel Watch',
      description: 'Precision timepiece NFT with animated dial mechanics.',
      file: '/demo/watch-1.png',
      creator: users[2].wallet,
      owner: owner(users[2].wallet),
      category: 'watches',
      createdAt: daysAgo(6),
    },
  },
  {
    _id: 'demo-sale-4',
    saleId: '104',
    type: 'auction',
    status: 'live',
    reservePrice: '320000000000000000',
    startDate: daysAgo(1),
    duration: 604800,
    seller: users[3].wallet,
    createdAt: daysAgo(2),
    bids: [
      bid('demo-user-1', '350000000000000000', hoursAgo(8)),
      bid('demo-user-6', '390000000000000000', hoursAgo(3)),
    ],
    nft: {
      _id: 'demo-nft-4',
      tokenId: '1004',
      title: 'Rose Gold Chronograph',
      description: 'Elegant chronograph collectible for discerning collectors.',
      file: '/demo/watch-2.png',
      creator: users[3].wallet,
      owner: owner(users[3].wallet),
      category: 'watches',
      createdAt: daysAgo(7),
    },
  },
  {
    _id: 'demo-sale-5',
    saleId: '105',
    type: 'auction',
    status: 'live',
    reservePrice: '120000000000000000',
    startDate: daysAgo(0),
    duration: 604800,
    seller: users[4].wallet,
    createdAt: daysAgo(1),
    bids: [bid('demo-user-2', '140000000000000000', hoursAgo(5))],
    nft: {
      _id: 'demo-nft-5',
      tokenId: '1005',
      title: 'Studio Crossbody',
      description: 'Compact crossbody rendered in premium digital leather.',
      file: '/demo/bag-3.png',
      creator: users[4].wallet,
      owner: owner(users[4].wallet),
      category: 'fashion',
      createdAt: daysAgo(3),
    },
  },
  {
    _id: 'demo-sale-6',
    saleId: '106',
    type: 'auction',
    status: 'live',
    reservePrice: '800000000000000000',
    startDate: daysAgo(1),
    duration: 604800,
    seller: users[6].wallet,
    createdAt: daysAgo(2),
    bids: [
      bid('demo-user-3', '850000000000000000', hoursAgo(10)),
      bid('demo-user-7', '920000000000000000', hoursAgo(1)),
    ],
    nft: {
      _id: 'demo-nft-6',
      tokenId: '1006',
      title: 'Platinum Tourbillon',
      description: 'Flagship horology piece with exposed movement artwork.',
      file: '/demo/watch-3.png',
      creator: users[6].wallet,
      owner: owner(users[6].wallet),
      category: 'watches',
      createdAt: daysAgo(8),
    },
  },
  {
    _id: 'demo-sale-7',
    saleId: '107',
    type: 'auction',
    status: 'live',
    reservePrice: '950000000000000000',
    startDate: daysAgo(0),
    duration: 604800,
    seller: users[5].wallet,
    createdAt: daysAgo(1),
    bids: [],
    nft: {
      _id: 'demo-nft-7',
      tokenId: '1007',
      title: 'Alpine Horizon',
      description: 'Large-format nature photography minted as a single edition.',
      file: '/demo/nature.png',
      creator: users[5].wallet,
      owner: owner(users[5].wallet),
      category: 'photography',
      createdAt: daysAgo(4),
    },
  },
  {
    _id: 'demo-sale-8',
    saleId: '108',
    type: 'auction',
    status: 'live',
    reservePrice: '200000000000000000',
    startDate: daysAgo(2),
    duration: 604800,
    seller: users[7].wallet,
    createdAt: daysAgo(3),
    bids: [bid('demo-user-4', '230000000000000000', hoursAgo(7))],
    nft: {
      _id: 'demo-nft-8',
      tokenId: '1008',
      title: 'Velvet Evening Clutch',
      description: 'Evening clutch with iridescent shader effects.',
      file: '/demo/purse.png',
      creator: users[7].wallet,
      owner: owner(users[7].wallet),
      category: 'fashion',
      createdAt: daysAgo(5),
    },
  },
  {
    _id: 'demo-sale-fp-1',
    saleId: '201',
    type: 'fixed-price',
    status: 'live',
    price: '450000000000000000',
    startDate: daysAgo(1),
    duration: 604800,
    seller: users[1].wallet,
    createdAt: daysAgo(2),
    bids: [],
    nft: {
      _id: 'demo-nft-9',
      tokenId: '1009',
      title: 'Heritage Duffel',
      description: 'Travel-ready duffel with embossed monogram details.',
      file: '/demo/bag-4.png',
      creator: users[1].wallet,
      owner: owner(users[1].wallet),
      category: 'fashion',
      createdAt: daysAgo(6),
    },
  },
  {
    _id: 'demo-sale-fp-2',
    saleId: '202',
    type: 'fixed-price',
    status: 'live',
    price: '600000000000000000',
    startDate: daysAgo(0),
    duration: 604800,
    seller: users[3].wallet,
    createdAt: daysAgo(1),
    bids: [],
    nft: {
      _id: 'demo-nft-10',
      tokenId: '1010',
      title: 'Carbon Fiber Diver',
      description: 'Sport diver watch NFT with luminous bezel animation.',
      file: '/demo/watch-4.png',
      creator: users[3].wallet,
      owner: owner(users[3].wallet),
      category: 'watches',
      createdAt: daysAgo(9),
    },
  },
];

export default sales;

export const salesById = sales.reduce((acc, sale) => {
  acc[sale._id] = sale;
  return acc;
}, {});

export const salesByNftId = sales.reduce((acc, sale) => {
  acc[sale.nft._id] = sale;
  return acc;
}, {});
